import { Box, color, StyleProps, useColorMode } from 'deepstash-ui';
import React from 'react';
import { createGradient } from 'utils/constants';
import { getTintHex } from 'utils/global';

interface SourceSplashscreenBackgroundProps {
  themeColor?: string;
  customGradient?: string;
  customHeight?: string;
}

const SourceSplashscreenBackground: React.FC<
  SourceSplashscreenBackgroundProps & StyleProps
> = ({ themeColor, customGradient, customHeight, ...props }) => {
  const { colorMode } = useColorMode();

  return (
    <Box
      position="absolute"
      height={customHeight ?? '100vh'}
      width="100%"
      top={0}
      left={0}
      overflow="hidden"
      {...props}
    >
      <Box
        position="absolute"
        height="100%"
        width="100%"
        top={0}
        left={0}
        background={
          customGradient ??
          createGradient(
            getTintHex({
              ogColor: themeColor ?? '',
              opacity: 0.7,
              colorScheme: colorMode,
            }),
            90,
          )
        }
      />
      <Box
        position="absolute"
        height="100%"
        width="100%"
        top={0}
        left={0}
        background={createGradient(color[colorMode].background, 270)}
      />
    </Box>
  );
};

export default SourceSplashscreenBackground;
